module.exports = __webpack_public_path__ + "static/media/spicy-piri-piri-mb-fr.19b18bf0.jpg";